/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'support': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M26.8 19.1v-6.3c0-.1.1-.2.2-.2h.2v6.7H27c-.1 0-.2-.1-.2-.2zm2.3.2h-.2v-6.7h.2c.7 0 1.3.6 1.3 1.3v4.2c-.1.7-.6 1.2-1.3 1.2zm-11 11h-4.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h4.2c.4 0 .7.3.7.7s-.3.7-.7.7zm-15-11h-.2c-.7 0-1.3-.6-1.3-1.3v-4.2c0-.7.6-1.3 1.3-1.3h.2v6.8zm1.7-6.7H5c.1 0 .2.1.2.2v6.3c0 .1-.1.2-.2.2h-.2v-6.7zM29.1 11h-1.3C27.3 4.8 22.2 0 16 0S4.7 4.8 4.2 11H2.9C1.3 11 0 12.3 0 13.9v4.2C0 19.7 1.3 21 2.9 21H5c1 0 1.9-.8 1.9-1.9v-6.3c0-.7-.4-1.3-1-1.7.3-5.3 4.7-9.5 10.1-9.5 5.4 0 9.8 4.2 10.1 9.5-.6.3-1 1-1 1.7v6.3c0 .7.4 1.4 1 1.7v1.5c0 3.3-2.5 6.1-5.8 6.4-.4-.9-1.2-1.5-2.2-1.5h-4.2c-1.3 0-2.4 1.1-2.4 2.4 0 1.3 1.1 2.4 2.4 2.4h4.2c1 0 1.9-.7 2.3-1.6 4.2-.4 7.5-3.9 7.5-8.1V21h1.3c1.6 0 2.9-1.3 2.9-2.9v-4.2c-.1-1.6-1.4-2.9-3-2.9z" fill-rule="evenodd" clip-rule="evenodd"/>'
  }
})
